import { createContext, useContext, useRef, useState } from 'react';
import AlertNotification from '../components/AlertNotification';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState({
        show: false,
        title: '',
        message: '',
        type: 'error', // can be 'error', 'success', 'info', etc.
        actions: []
    });
    const hideTimerRef = useRef(null);

    // duration (ms): auto-dismiss after this long. Omit to keep the
    // notification until the user closes it (the right call for errors).
    const showNotification = (title, message, type = 'error', actions = [], duration = null) => {
        clearTimeout(hideTimerRef.current);

        setNotification({
            show: true,
            title,
            message,
            type,
            actions
        });

        if (duration) {
            hideTimerRef.current = setTimeout(() => {
                setNotification(prev => ({ ...prev, show: false }));
            }, duration);
        }
    };

    const hideNotification = () => {
        clearTimeout(hideTimerRef.current);
        setNotification(prev => ({ ...prev, show: false }));
    };

    return (
        <NotificationContext.Provider value={{ notification, showNotification, hideNotification }}>
            {children}
            <AlertNotification
                show={notification.show}
                title={notification.title}
                message={notification.message}
                type={notification.type}
                actions={notification.actions}
                onClose={hideNotification}
            />
        </NotificationContext.Provider>
    );
}

export function useNotification() {
    return useContext(NotificationContext);
}
